module.exports = __webpack_public_path__ + "img/expand.df598011.svg";